var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("table", { staticClass: "table table-hover" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.formattedValue, function (item, index) {
          return _c("tr", { key: index }, [
            _c(
              "td",
              [
                _c("FormInput", {
                  staticStyle: { "margin-bottom": "0" },
                  model: {
                    value: item.key,
                    callback: function ($$v) {
                      _vm.$set(item, "key", $$v)
                    },
                    expression: "item.key",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("FormInput", {
                  staticStyle: { "margin-bottom": "0" },
                  model: {
                    value: item.value,
                    callback: function ($$v) {
                      _vm.$set(item, "value", $$v)
                    },
                    expression: "item.value",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("td", [
              _c(
                "span",
                {
                  staticClass: "clickable text-danger",
                  on: {
                    click: function ($event) {
                      return _vm.destroy(index)
                    },
                  },
                },
                [_vm._v("Delete")]
              ),
            ]),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("tfoot", [
        _c("tr", [
          _c("td", { staticClass: "text-center", attrs: { colspan: "10" } }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary btn-add",
                attrs: { type: "button" },
                on: { click: _vm.add },
              },
              [_c("i", { staticClass: "fas fa-plus text-primary" })]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Key")]),
        _vm._v(" "),
        _c("th", [_vm._v("Value")]),
        _vm._v(" "),
        _c("th", [_vm._v("Actions")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }